export enum Ids {
  rent = 'rent',
  rentLocations = 'rentLocations',
  rentOffers = 'rentOffers',
  property = 'property',
  tenant = 'tenant',
  tenantApplication = 'tenantApplication',
  tenantService = 'tenantService',
}
